<section class="flex flex-col gap-4 bg-white lg:flex-row lg:gap-8 lg:rounded-lg shadow-sm shadow-black py-4 border-2 border-purple-700 lg:m-5 overflow-hidden">
    
    <div class="w-full shrink-0 lg:w-64">
      <div class="m-3 h-auto w-auto overflow-hidden rounded-lg bg-white dark:bg-white">
       
        <div class="relative rounded " (click)="trackingOrder()">
          <img [src]="trackProductImageUrl+trackDetails?.product_image"
          alt="Headless UI"  class="h-36 w-full m-auto object-contain my-auto transform transition duration-500 hover:scale-95">
           
        </div>
      
            <!-- <div class="relative">
              
              <button mat-button (click)="openDialog()" class="absolute top-0 bg-blue-500 text-white p-2 rounded hover:bg-blue-800">Quick View</button>
            </div>
             -->
           
            <div class="lg:ml-8 my-3" >
            <svg class="w-4 h-4 mx-px fill-current text-orange-600" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14">
            <path
                d="M6.43 12l-2.36 1.64a1 1 0 0 1-1.53-1.11l.83-2.75a1 1 0 0 0-.35-1.09L.73 6.96a1 1 0 0 1 .59-1.8l2.87-.06a1 1 0 0 0 .92-.67l.95-2.71a1 1 0 0 1 1.88 0l.95 2.71c.13.4.5.66.92.67l2.87.06a1 1 0 0 1 .59 1.8l-2.3 1.73a1 1 0 0 0-.34 1.09l.83 2.75a1 1 0 0 1-1.53 1.1L7.57 12a1 1 0 0 0-1.14 0z">
            </path>
          </svg>
          <!-- <span class="text-gray-600 font-medium mr-3 uppercase text-xs">{{product?.items?.bra}}</span> -->
        
          <p class="text-lg font-bold text-black truncate block capitalize">{{trackDetails?.product_name}}</p>
       <div class="items-center mb-2">
            <p class="text-xl font-semibold text-purple-700 cursor-auto ">Rs.{{trackDetails?.product_price}}</p>
              <!-- <p class="text-sm text-red-600 cursor-auto ml-2">{{trackDetails?.product_color}}</p> -->
            
           </div>
          
        
      </div>
      <!-- <div *ngIf="wishListProduct === 0">
      <h1>Data Not Found</h1>
      </div>
       -->
      </div>
    
      
      </div>



    <div class="mx-auto w-full min-w-0 max-w-5xl px-4 sm:px-6 lg:px-8">
        <div class="text-center">
            <h2 class="mt-1 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl lg:text-5xl">Order Status
            </h2>
        </div>
        <ul class="mt-8 grid w-full max-w-4xl grid-cols-1 gap-8 sm:mt-12 lg:mt-10 lg:grid-cols-4 lg:gap-6">
            <li class="flex-start group relative flex lg:flex-col">
                <span
                    class="absolute left-[18px] top-14 h-[calc(100%_-_32px)] w-px bg-gray-300 lg:right-0 lg:left-auto lg:top-[18px] lg:h-px lg:w-[calc(100%_-_72px)]"
                    aria-hidden="true"></span>
                <div
                    class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border  border-gray-300 bg-gray-50 transition-all duration-200">
                    <!-- <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"
                        class="h-5 w-5 text-purple-700">
                        <path
                            d="M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 5C21 6.65685 16.9706 8 12 8C7.02944 8 3 6.65685 3 5M21 5C21 3.34315 16.9706 2 12 2C7.02944 2 3 3.34315 3 5M21 5V19C21 20.6569 16.9706 22 12 22C7.02944 22 3 20.6569 3 19V5"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg> -->
                    1
                </div>
                <div class="ml-6 lg:ml-0 lg:mt-10">
                    <h3
                        class="text-xl font-bold text-gray-900 before:mb-2 before:block before:font-mono before:text-sm before:text-gray-500">
                        Order Confirmed
                    </h3>
                    <h4 class="mt-2 text-base text-gray-700">Mon, 8th Jan</h4>
                </div>
            </li>
            <li class="flex-start group relative flex lg:flex-col">
                <span
                    class="absolute left-[18px] top-14 h-[calc(100%_-_32px)] w-px bg-gray-300 lg:right-0 lg:left-auto lg:top-[18px] lg:h-px lg:w-[calc(100%_-_72px)]"
                    aria-hidden="true"></span>
                <div
                    class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-gray-50 transition-all duration-200 ">
                   2
                </div>
                <div class="ml-6 lg:ml-0 lg:mt-10">
                    <h3
                        class="text-xl font-bold text-gray-900 before:mb-2 before:block before:font-mono before:text-sm before:text-gray-500">
                        Shipped
                    </h3>
                    <h4 class="mt-2 text-base text-gray-700">wed, 9th Jan</h4>
                </div>
            </li>
            <li class="flex-start group relative flex lg:flex-col">
                <span
                    class="absolute left-[18px] top-14 h-[calc(100%_-_32px)] w-px bg-gray-300 lg:right-0 lg:left-auto lg:top-[18px] lg:h-px lg:w-[calc(100%_-_72px)]"
                    aria-hidden="true"></span>
                <div
                    class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-gray-50 transition-all duration-200 ">
                  3
                </div>
                <div class="ml-6 lg:ml-0 lg:mt-10">
                    <h3
                        class="text-xl font-bold text-gray-900 before:mb-2 before:block before:font-mono before:text-sm before:text-gray-500">
                        Out For Delivery
                    </h3>
                    <h4 class="mt-2 text-base text-gray-700">Mon, 12th march</h4>
                </div>
            </li>
            <li class="flex-start group relative flex lg:flex-col">
                <div
                    class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-gray-300 bg-gray-50 transition-all duration-200 ">
                  4
                </div>
                <div class="ml-6 lg:ml-0 lg:mt-10">
                    <h3
                        class="text-xl font-bold text-gray-900 before:mb-2 before:block before:font-mono before:text-sm before:text-gray-500">
                        Deliverd
                    </h3>
                    <h4 class="mt-2 text-base text-gray-700">sun, 8th Apr</h4>
                </div>
            </li>
        </ul>
    </div>
</section>